import React from "react";
import style from "../PrivacyPolicy/privacypolicy.module.css";

const AcceptableUsePolicy = () => {
  return (
    <div>
      <div className={style.privacyPolicyContainer}>
        <div className="container">
          <div className={style.mainprivacypolicyheading}>
            <div className={style.privacyHeading}>
              {" "}
              Acceptable Use Policy
              <br />{" "}
              {/* <div className={style.subHeading}>
              {" "}
              Site Privacy Policy
            </div> */}
            </div>
          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>Effective Date: <span>February 1, 2026 </span></div>
            <div className={style.sectionsubheading}>
              This Acceptable Use Policy (“Policy”) describes prohibited and restricted activities when using FundLife.me (“FundLife.me,” “FundLife,” “we,” “us,” or “our”). This Policy is incorporated into the FundLife.me Terms of Service and applies to all users of the platform.
              FundLife.me is a for-profit technology platform. We provide fundraising tools but do not control or verify how funds are ultimately used. To protect users and platform integrity, certain uses are not permitted.
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectioninnerHeading}>
              1. General Use Standards
            </div>
            <div className={style.privacyText}>
              You agree to use FundLife.me responsibly, lawfully, and honestly.
              You may not use FundLife.me in any way that:
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                    Violates applicable laws or regulations
                  </li>
                  <li>
                    Is misleading, deceptive, or fraudulent
                  </li>
                  <li>
                    Harms, exploits, or threatens others
                  </li>
                  <li>
                    Undermines trust in the platform
                  </li>
                </ul>
              </div>
              We reserve the right to remove content or restrict access to protect users and the platform.
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
              2. Prohibited Fundraising Activities
            </div>
            <div className={style.privacyText}>
              You may not create or support fundraisers that involve or promote: <br></br>
              <b>Illegal or Fraudulent Activity </b>
              <div className={style.privacytextlist}>

                <li>
                  <ul>
                    Scams, misrepresentation, or deceptive fundraising
                  </ul>

                </li>
                <li>
                  <ul>
                    False claims about how funds will be used
                  </ul>

                </li>
                <li>
                  <ul>
                    Knowingly misleading donors
                  </ul>
                </li>
              </div>
              <b>Financial Misconduct  </b>
              <div className={style.privacytextlist}>
                <li>
                  <ul>
                    Money laundering or evasion of taxes
                  </ul>
                </li>
                <li>
                  <ul>
                    Raising funds on behalf of sanctioned individuals or entities
                  </ul>

                </li>
                <li>
                  <ul>
                    Unauthorized collection of funds for another person or organization
                  </ul>
                </li>
              </div>

              <b>Violence, Harm, or Criminal Conduct  </b>
              <div className={style.privacytextlist}>

                <li>
                  <ul>
                    Violence, threats, or physical harm
                  </ul>

                </li>
                <li>
                  <ul>
                    Terrorist activity or extremist organizations
                  </ul>

                </li>
                <li>
                  <ul>
                    Hate groups or activities promoting discrimination or hostility
                  </ul>
                </li>
              </div>
              <b>Sexual or Exploitative Content  </b>
              <div className={style.privacytextlist}>

                <li>
                  <ul>
                    Sexual services, pornography, or sexually explicit content
                  </ul>

                </li>
                <li>
                  <ul>
                    Exploitation or abuse of minors
                  </ul>

                </li>
                <li>
                  <ul>
                    Human trafficking or coercion
                  </ul>
                </li>
              </div>
              <b>Regulated or Restricted Goods  </b>
              <div className={style.privacytextlist}>

                <li>
                  <ul>
                    Drugs or controlled substances
                  </ul>

                </li>
                <li>
                  <ul>
                    Weapons, ammunition, or explosives
                  </ul>

                </li>
                <li>
                  <ul>
                    Gambling, raffles, lotteries, or games of chance unless explicitly permitted by law and approved in writing by FundLife.me
                  </ul>
                </li>
              </div>
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
              2. Public and Non-Public Information
            </div>
            <div className={style.privacyText}>
              Fundraising pages and related content may be publicly visible by default. Any information you choose to post publicly may be viewed, shared, or copied by others. Please avoid sharing personal or sensitive information unless you intend for it to be public.
              Non-public communications (such as messages sent to FundLife support) are treated as private and used only to provide assistance, maintain platform integrity, and enforce our policies.
            </div>

          </div>
          <div className="my-5">
            <div className={style.sectionHeading}>
              3. Personal Data and Privacy Violations
            </div>
            <div className={style.privacyText}>
              You may not:
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                    Share personal or sensitive information about others without permission
                  </li>
                  <li>
                    Post government IDs, financial account numbers, medical records, or information about minors
                  </li>
                  <li>
                    Impersonate another person or organization
                    If you include another person’s story, image, or information, you confirm you have the right and consent to do so.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="my-5">
            <div className={style.sectionHeading}>
              4. Hate, Harassment, and Abuse
            </div>
            <div className={style.privacyText}>
              FundLife.me does not permit content that:
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                    Harasses, threatens, or bullies others
                  </li>
                  <li>
                    Post government IDs, financial account numbers, medical records, or information about minors
                  </li>
                  <li>
                    Encourages self-harm or harm to others
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="my-5">
            <div className={style.sectionHeading}>
              5. Intellectual Property Violations
            </div>
            <div className={style.privacyText}>
              You may not post content that:
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                    Infringes copyrights, trademarks, or other intellectual property rights
                  </li>
                  <li>
                    Uses logos, branding, or protected materials without permission
                  </li>
                </ul>
                You are responsible for ensuring you have the right to use all content you upload.
              </div>
            </div>
          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
              6. Platform Integrity and Misuse
            </div>
            <div className={style.privacyText}>
              You may not:
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                    Attempt to bypass platform safeguards or security measures
                  </li>
                  <li>
                    Use bots, scripts, or automated tools without permission
                  </li>
                  <li>
                    Interfere with platform operations or other users’ experience
                  </li>
                  <li>
                    Circumvent fees or payment systems
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="my-5">

            <div className={style.sectionHeading}>


              7. Enforcement and Remedies
            </div>
            <div className={style.privacyText}>
              FundLife.me may take action at its discretion, including:
              <div className={style.privacytextlist}>
                <ul >
                  <li>
                    Removing content or fundraisers
                  </li>
                  <li>
                    Suspending or terminating accounts
                  </li>
                  <li>
                    Withholding or delaying fund disbursement where required by law or platform policy
                  </li>
                  <li>
                    Cooperating with law enforcement or regulatory authorities
                  </li>
                </ul>
                We are not obligated to provide advance notice before taking action.
              </div>
            </div>


          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>8. Reporting Violations  </div>
            <div className={style.privacyTextcontact}>
              <p>If you believe a fundraiser or user violates this Policy, please contact:  </p>
              <b>FundLife.me </b>
              <p>Email: info@Fundlife.me </p>
              <p>Reports are reviewed as resources permit and handled in accordance with applicable law and platform policies. </p>
            </div>

          </div>
          <div className="my-5">

            <div className={style.sectionHeading}>
          9. Policy Updates 
            </div>
            <div className={style.privacyText}>
              This Acceptable Use Policy may be updated from time to time. Continued use of FundLife.me after changes are posted constitutes acceptance of the revised Policy. 
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default AcceptableUsePolicy;
